import { render } from "./MaterialSelect.vue?vue&type=template&id=4f381758"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"

import "./MaterialSelect.vue?vue&type=style&index=0&id=4f381758&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__